import React, { useState, useEffect } from 'react'
import classNames from 'classnames'
import TablePagination from '@mui/material/TablePagination'

import { API, API_ROUTER } from '../../api'
import useHost from '../../hooks/useHost'
import { HOSTS } from '../../constants'

import RatingTable from './table'
import Filters from './components/Filters'
import {
  INITIAL_FILTERS_STATE,
  TABLE_PAGINATION_SELECT_PROPS,
  TABLE_PAGINATION_SX,
} from './config'
import { formatFiltersForBackend, filterGamesByUserRating } from './utils'

import './LeaderBoard.css'
import Styled from './style'
import styles from './styles.module.scss'

const LeaderBoard = () => {
  const [participants, setParticipants] = useState()
  const [selectedGame, setSelectedGame] = useState(null)
  const [games, setGames] = useState([])
  const [ratingPage, setRatingPage] = useState(1)
  const [rowsPerPage, setRowsPerPage] = useState(100)

  const [filters, setFilters] = useState(INITIAL_FILTERS_STATE)

  const [isTableLoading, setIsTableLoading] = useState(false)

  const isM87Host = useHost(HOSTS.m87PassportGg)
  const isM87DevHost = useHost(HOSTS.m87DevPassportGg)
  const isM87 = isM87Host || isM87DevHost

  const onGameChange = game => {
    setSelectedGame(game)
    setRatingPage(1)
  }

  const handleFiltersChange = newFilters => {
    setFilters(newFilters)
    setRatingPage(1) // Reset to first page when filters change
  }

  const clearFilters = () => {
    setFilters(INITIAL_FILTERS_STATE)
    setRatingPage(1)
  }

  const pageChange = (_, value) => {
    setRatingPage(value + 1) // Convert from 0-based (MUI) to 1-based (API)
  }
  const handleChangeRowsPerPage = event => {
    setRowsPerPage(parseInt(event.target.value, 10))
    setRatingPage(1)
  }

  // массив с участниками
  useEffect(() => {
    const fetchRatingTable = async () => {
      setIsTableLoading(true)
      try {
        const res = await API.request({
          ...API_ROUTER.rating.getRatingTable,
          pathKeys: {
            page: ratingPage ? ratingPage : 1,
            limit: rowsPerPage ? rowsPerPage : 100,
          },
          data: {
            gameId: selectedGame?.id || '',
            ...formatFiltersForBackend(filters),
          },
        })
        setParticipants(res)
      } catch (err) {
        console.log(err)
      } finally {
        setIsTableLoading(false)
      }
    }

    fetchRatingTable()
  }, [selectedGame, ratingPage, rowsPerPage, filters])

  // массив с играми
  useEffect(() => {
    const fetchGames = async () => {
      try {
        const res = await API.request({
          ...API_ROUTER.games.getGames,
        })
        setGames(filterGamesByUserRating(res.games))
      } catch (err) {
        console.log(err)
      }
    }

    fetchGames()
  }, [])

  return (
    <div className='rating__container' data-testid='rating-page'>
      {!isM87 && (
        <Styled.RatingCol>
          <Filters
            filters={filters}
            onFiltersChange={handleFiltersChange}
            onClearFilters={clearFilters}
          />
        </Styled.RatingCol>
      )}
      <section className={classNames('leaderbord')}>
        <div>
          <RatingTable
            ratingData={participants?.rows}
            onGameChange={onGameChange}
            games={games}
            selectedGame={selectedGame?.title}
            isLoad={isTableLoading}
          />
          <div className={styles.paginatorWrapper}>
            <div className={styles.paginationContainer}>
              <TablePagination
                component='div'
                sx={TABLE_PAGINATION_SX}
                SelectProps={TABLE_PAGINATION_SELECT_PROPS}
                classes={{ div: styles.pagination }}
                count={participants?.paginator?.totalResults || 0}
                page={Math.max(
                  0,
                  (participants?.paginator?.currentPage || 1) - 1
                )}
                onPageChange={pageChange}
                rowsPerPage={rowsPerPage}
                onRowsPerPageChange={handleChangeRowsPerPage}
              />
            </div>
          </div>
        </div>
      </section>
    </div>
  )
}

export default LeaderBoard
